import noUiSlider from "nouislider"
import currencyFormat from "scripts/utils/currencyFormat"
import sliders from "scripts/components/sliders"
import renderModalCertificateOrder from "scripts/components/react/ModalCertificateOrder"
import { binarySearch } from "scripts/utils/binarySearch"
import addGlobalEvent from "scripts/utils/addGlobalEvent"
import header from "scripts/components/header"
import response from "scripts/components/response"
import forms from "scripts/components/forms"
import modals from "scripts/components/modals"
import wishlist from "scripts/components/wishlist/wishlist"
import Select from "scripts/components/select"
import setAppLinksParams from "scripts/components/setAppLinksParams"
import { GAPageView } from "scripts/components/ga/page_view"
import { initSupport } from "scripts/components/support/support";
import { initLazyLoadingRecaptcha } from "scripts/components/recaptcha/recaptcha";
import { installGoogleTranslateShim } from "scripts/utils/googleTranslateShim";

installGoogleTranslateShim();

const sliderInit = () => {
  const stepsSlider = document.getElementById("slider")
  const sliderInput = document.getElementById("slider-input")
  let sliderObj

  if (stepsSlider) {
    sliderObj = noUiSlider.create(stepsSlider, {
      start: 2000,
      connect: [true, false],
      range: {
        min: 250,
        // '20%': [3000, 100],
        // '30%': [10000, 500],
        // '50%': [20000, 1000],

        // '40%': [2000, 100],
        // '60%': [5000, 1000],

        // '10%': [500, 50],
        // '20%': [1000, 100],
        // '30%': [1500, 100],
        // '40%': [2000, 100],
        // '50%': [3000, 200],
        // '60%': [5000, 500],
        // '70%': [10000, 1000],
        // '80%': [15000, 1000],
        // '90%': [20000, 2000],

        "10%": [500, 50],
        "20%": [1000, 50],
        "30%": [1500, 50],
        "40%": [2000, 50],
        "50%": [3000, 50],
        "60%": [5000, 50],
        "70%": [10000, 50],
        "80%": [15000, 50],
        "90%": [20000, 50],
        max: 50000,
      },
      step: 50,
      tooltips: true,
      format: {
        to: currencyFormat,
        from: (val) => val,
      },
      pips: {
        mode: "values",
        // values: [250, 50000],
        values: [250, 500, 1000, 1500, 2000, 3000, 5000, 10000, 15000, 20000, 50000],
        density: 100,
        // stepped: true,
        format: {
          to: currencyFormat,
          from: (val) => val.replace(" ", ""),

          // from: function (value) {
          //     return Math.round(value);
          // },
        },
        // filter: filterPips,
        // format: wNumb({
        //     decimals: 2,
        //     prefix: '€'
        // })
      },
    })
  }
  var activePips = [null]
  const pipsRefs = stepsSlider.querySelectorAll(".noUi-value")
  // sliderObj.target.querySelectorAll('.noUi-value')
  stepsSlider.addEventListener("click", function (e) {
    if (e.target.classList.contains("noUi-value")) {
      const value = e.target.dataset.value
      sliderObj.set(value)
    }
  })

  stepsSlider.noUiSlider.on("update", function (values, handle) {
    // Remove the active class from the current pip
    if (activePips[handle]) {
      activePips[handle].classList.remove("active-pip")
    }

    // Match the formatting for the pip
    const dataValue = Number(values[handle].replace(" ", ""))

    const [, closestPipIdx] = binarySearch(
      sliderObj.options.pips.values,
      dataValue
    )

    activePips[handle] = pipsRefs[closestPipIdx]

    // Add the active class
    if (activePips[handle]) {
      activePips[handle].classList.add("active-pip")
    }

    // Set input value
    sliderInput.value = dataValue
  })

  sliderInput.addEventListener("change", function () {
    sliderObj.set(this.value)
  })
}

const startScripts = () => {
  GAPageView()
  sliderInit()
  sliders()

  header()
  response()
  forms()
  modals()
  wishlist()

  addGlobalEvent(document, 'click', '.js_activated_toggle', function activateToggleBlock() {
    if (!this) return;
    this.closest(".js_activated_block").classList.toggle('active');
  });

  // Open certificate order modal listener
  document.querySelector(".js_do_certificate_order").addEventListener("click", () => {
    const toOrderValue = Number(document.getElementById("slider-input").value)
    renderModalCertificateOrder(toOrderValue)
  })

  window.customSelect = new Select()

  setAppLinksParams();
  initSupport();
  initLazyLoadingRecaptcha();
}

document.addEventListener("DOMContentLoaded", startScripts)
